export {default} from './CollectScreenContent';
